import React, { useEffect, useState } from 'react'
import ModalCustom from '../../../../modal-custom'
import { Button, Col, Form, Row } from 'react-bootstrap'
import LabelCustom from '../../../../label-custom'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {
  deleteLeaveTypeAPI,
  putLeaveTypeAPI
} from '../../../../../services/welfare-leave'
import SwalCustom from '../../../../../alert/swal-custom'
import Swal from 'sweetalert2'
import { TXTSUCCESS } from '../../../../../Constants'
import Error_false from '../../../../error/error-false'
import Error_500 from '../../../../error/error-500'
const schema = yup
  .object({
    leaveUsed: yup.string().required('Please, Choose your used')
  })
  .required()

export default function ModalLeaveEdit({
  handleModalEditClose,
  showModalEditOpen,
  isModalEditOpen,
  isSave,
  setIsSave,
  orgId,
  code,
  getLeave,
  dataEdit,
  handleKeyDownNum
}) {
  const schema = yup
    .object({
      leaveTotal: yup.string().required('Please, Fill total')
    })
    .required()

  // const schema = yup.object({
  //   leaveTotal: yup.string().required('Please, Fill total'),
  //   leaveUsed: yup.string().when('leaveTypeId', {
  //     is: 3,
  //     then: yup.string().required('Please, Fill used count'),
  //     otherwise: yup.string().notRequired()
  //   })
  // }).required();

  const {
    control,
    setError,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    setValue('leaveTotal', dataEdit.total)
    setValue('leaveType', dataEdit.leave_leave)
    setValue('leaveUsed', dataEdit.used)
    setValue('leaveTypeId', dataEdit?.leave_type_id)
  }, [])

  const [total, setTotal] = useState()
  const onSubmit = (d) => {
    const body = {
      orgId,
      code,
      leaveId: dataEdit?.leave_id,
      total: parseFloat(d?.leaveTotal),
      used: parseFloat(d?.leaveUsed)
    }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to create new?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        editLeave(body)
      }
    })
  }

  const editLeave = async (body) => {
    const res = await putLeaveTypeAPI(body)
    setIsSave(false)
    if (!res) {
      setIsSave(false)
      return
    }
    if (res.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        getLeave()
        Swal.close()
      })
    } else {
      Error_false(res)
    }

    handleModalEditClose()
    setIsSave(false)
  }

  const handleDelete = () => {
    const body = {
      orgId,
      code,
      leaveId: dataEdit?.leave_id
    }
    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        deleteLeave(body)
      }
    })
  }

  const deleteLeave = async (body) => {
    try {
      const res = await deleteLeaveTypeAPI(body)
      if (res.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          setIsSave(false)
          handleModalEditClose()
          getLeave({ orgId, code })
        })
      } else {
        setIsSave(false)
        Error_false(res)
      }
      setIsSave(false)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }
  return (
    <ModalCustom
      width={500}
      open={showModalEditOpen}
      onCancel={handleModalEditClose}
    >
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label>Edit Leave</label>

        <Col md={12}>
          <LabelCustom text={'Leave Type'} />
          <Controller
            name={'leaveType'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <>
                <Form.Control
                  disabled
                  value={dataEdit?.leave_type}
                  onChange={(value) => {
                    onChange(value)
                    setTotal(value?.total)
                  }}
                />
              </>
            )}
          />
          {errors.leaveType?.message && (
            <label className="small text-danger">
              {errors.leaveType.message}
            </label>
          )}
        </Col>
        <Col md={12}>
          <Row>
            <Col xl={6}>
              <LabelCustom text={'Total'} />
              <Controller
                name={'leaveTotal'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <>
                    <Form.Control
                      // disabled={dataEdit?.leave_type_id === 3 ? false : true}
                      value={value}
                      onChange={(e) => onChange(e.target.value)}
                      onKeyDown={handleKeyDownNum}
                    />
                  </>
                )}
              />
              {errors.leaveTotal?.message && (
                <label className="small text-danger">
                  {errors.leaveTotal.message}
                </label>
              )}
            </Col>
            <Col xl={6}>
              <LabelCustom text={'Used'} />
              <Controller
                name={'leaveUsed'}
                control={control}
                render={({ field: { onChange, value = '' } }) => (
                  <>
                    <Form.Control
                      type="number"
                      value={value}
                      onChange={(value) => {
                        onChange(value)
                      }}
                      onKeyDown={handleKeyDownNum}
                    />
                  </>
                )}
              />
              {errors.leaveUsed?.message && (
                <label className="small text-danger">
                  {errors.leaveUsed.message}
                </label>
              )}
            </Col>
          </Row>
        </Col>
        <Col xl={12} className="text-center mt-4">
          <Button
            className="px-4 me-2 bg-danger text-white"
            size="sm"
            variant="light"
            onClick={handleDelete}
          >
            Delete
          </Button>
          <Button
            className="px-4 me-2 text-primary "
            size="sm"
            variant="light"
            onClick={handleModalEditClose}
          >
            Close
          </Button>
          <Button type="submit" className="px-4" disabled={isSave} size="sm">
            {isSave ? 'Saving...' : 'Save'}
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
